import React, { useState, useEffect } from "react";

const SimListDropDown = ({ menuData }) => {
  const [activeDropdown, setActiveDropdown] = useState(0);
  const [activeSubmenu, setActiveSubmenu] = useState({});

  // Set the first submenu as active by default
  useEffect(() => {
    const defaultActive = {};
    menuData.forEach((item, index) => {
      if (item.hasDropdown && item.submenu.length > 0) {
        defaultActive[index] = 0; // Set the first submenu of each item as active by default
      }
    });
    setActiveSubmenu(defaultActive);
  }, []);

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const toggleSubmenu = (menuIndex, submenuIndex) => {
    setActiveSubmenu((prev) => ({
      ...prev,
      [menuIndex]: prev[menuIndex] === submenuIndex ? null : submenuIndex,
    }));
  };

  // Smooth scroll to specific section based on the id
  const scrollToSection = (sectionId) => {
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <div className="listwithdropdown">
        <ul className="menu">
          {menuData.map((item, index) => (
            <li key={index} className={item.hasDropdown ? "dropdown" : "withoutdropdown"}>
              <span
                className={`listmenu ${item.hasDropdown && activeDropdown === index ? "active" : ""}`}
                onClick={
                  item.hasDropdown
                    ? (e) => {
                        e.preventDefault();
                        toggleDropdown(index);
                      }
                    : undefined
                }
              >
                {item.icon}
                {item.title}
              </span>
              {item.hasDropdown && activeDropdown === index && (
                <ul className="submenu">
                  {item.submenu.map((subitem, subindex) => (
                    <li
                      key={subindex}
                      className={`submenulist ${activeSubmenu[index] === subindex ? "active" : ""}`}
                      onClick={() => {
                        toggleSubmenu(index, subindex);
                        scrollToSection(subitem.id_link); // Scroll to the section when submenu is clicked
                      }}
                    >
                      <span className="submenuname">{subitem.title}</span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SimListDropDown;
